import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface SignOnTrackerData {
  hours: number;
  scheduledPaymentDate: string | null;
  amount: number;
}

export interface SignOnTrackerResult {
  data?: SignOnTrackerData;
  loading: boolean;
  error?: string;
}

export const useSignOnTracker = (
  username?: string,
  enabled: boolean = true
): SignOnTrackerResult => {
  const client = useMyProviderDataClient();

  const [data, setData] = useState<SignOnTrackerData>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!enabled || !username) return;

    const load = async () => {
      try {
        setLoading(true);
        setError(undefined);

        const res = await client.get("/EmployeeInformation/SignOnTracker", {
          params: { username },
        });

        const row = Array.isArray(res.data) ? res.data[0] : res.data;
        if (row) {
          setData({
            hours: row.Hours ?? row.hours ?? 0,
            scheduledPaymentDate: row.ScheduledPaymentDate ?? row.scheduledPaymentDate ?? null,
            amount: row.Amount ?? row.amount ?? 0,
          });
        } else {
          setData(undefined);
        }
      } catch (err) {
        console.error(err);
        setError("Failed to load Sign On Tracker data.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, enabled, client]);

  return { data, loading, error };
};
